import { render, staticRenderFns } from "./verUsuario.vue?vue&type=template&id=29c2137b&"
import script from "./verUsuario.vue?vue&type=script&lang=js&"
export * from "./verUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports